import { useEffect } from "react";

// Intercepts all link clicks, plays exit animation on the card, then navigates.
// This gives a smooth slide-down → slide-up effect between ACUL screens.
export function useCardTransition() {
  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      const link = (e.target as HTMLElement).closest("a");
      if (!link?.href || link.target === "_blank") return;

      const card = document.querySelector(".tnf-card-vt") as HTMLElement | null;
      if (!card) return;

      e.preventDefault();
      const href = link.href;

      card.classList.add("is-exiting");
      setTimeout(() => {
        window.location.href = href;
      }, 320);
    };

    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, []);
}
